import useUser from 'store/user/useUser';

import Form from 'components/Form';
import RowContainer from '../Main/Survey/components/RowContainer';
import RowContent from '../Main/Survey/components/RowContent';

import { Typography, Stack, useTheme } from '@mui/material';

import useStudent from 'store/student/useStudent';

interface Props {
  disabled?: boolean;
  totalSize: number;
}

const ProfModeInfo = (props: Props) => {
  const { palette } = useTheme();

  const { totalSize } = props;
  const { student_name, student_no } = useStudent();

  const infos = [
    { title: 'nurse', value: student_name },
    { title: 'Student ID', value: student_no },
    { title: 'Volume', value: String(totalSize) + 'GB' },
  ];

  return (
    <RowContainer xs={12}>
      <RowContent title="nurse" titleRatio={1} childrenRatio={2.5}>
        <Form.MuiTextField
          value={student_name}
          InputProps={{ readOnly: true }}
        />
      </RowContent>
      <RowContent title="Student ID" titleRatio={1} childrenRatio={2.5}>
        <Form.MuiTextField value={student_no} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Volume" titleRatio={1} childrenRatio={4}>
        <Stack direction="row" spacing={2}>
          <Typography
            sx={{ color: `${palette.primary.main}` }}
            fontSize="14px"
            lineHeight="37.125px"
            display="inline"
          >
            {totalSize + 'GB'}
          </Typography>
          <Typography fontSize="14px" lineHeight="37.125px" display="inline">
            {' '}
            / 10GB
          </Typography>
          <Typography
            sx={{ color: `${palette.primary.main}` }}
            fontSize="14px"
            lineHeight="37.125px"
            display="inline"
          >
            Up to 500MB per file
          </Typography>
        </Stack>
      </RowContent>
    </RowContainer>
  );
};

export default ProfModeInfo;
